<template>
  <module-configuration :data="config" :errors="errors">
    <div slot="auth" class="l-row">
      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>
      <form-group label="Identificação do Usuário">
        <input class="form-input" v-model="config.auth.userId">
      </form-group>
      <form-group label="Chave da API">
        <input class="form-input" v-model="config.auth.apiKey">
      </form-group>
    </div>

    <panel title="API V2">
      <form-group label="Utilizar API V2 de integração">
        <label class="form-switch">
          <input type="checkbox" v-model="config.auth.useAPIV2">
          <span class="form-switch__indicator"></span>
        </label>
        <small class="form-help">Utilizar nova API Dafiti. Configura seus dados de API(chave, senha) * Ative apenas após atualizar seus dados da API corretamente</small>
      </form-group>
    </panel>

    <panel title="Produtos">
      <loader :loading="loadingProducts"/>
      <div class="l-row">
        <product-price-configuration :input="config.product.price"/>
        <form-group label="Redutor de estoque padrão">
          <input class="form-input" min="0" type="number" v-model="config.product.stock.reducer">
        </form-group>

        <form-group label="Origem" v-if="origins.length">
          <select class="form-select" v-model="config.product.origin">
            <option :value=null>Escolha</option>
            <option v-for="origin in origins" :value="origin">{{ origin }}</option>
          </select>
        </form-group>

        <form-group label="País de Origem" v-if="originsCountry.length">
          <select class="form-select" v-model="config.product.originCountry">
            <option :value=null>Escolha</option>
            <option v-for="originCountry in originsCountry" :value="originCountry">{{ originCountry }}</option>
          </select>
        </form-group>

        <form-group label="Redimensionar imagens">
          <select class="form-select" v-model="config.product.image.resize">
            <option v-for="resizeImageOption in resizeImageOptions" :value="resizeImageOption">{{$t(`${resizeImageOption}.label`) }}</option>
          </select>
        </form-group>
        <form-group v-if="config.product.image.resize" label="Identificador da conta">
          <input class="form-input" v-model="config.auth.identifier">
          <small class="form-help">O identificador da conta é igual ao nome do seu dominio.</small>
          <small class="form-help">No exemplo: "www.placemarket.com.br" o identificador da conta seria "placemarket".</small>
        </form-group>
      </div>
    </panel>

    <panel :title="$t('expediter.label')">
      <expediter-configuration :expediter="config.order.expediter"/>
    </panel>

    <panel :title="$t('order.label')">
      <order-retrieve-date-configuration :orderConfigs="config.order"/>
      <div class="l-row">
        <form-group :columns="columns || 2" label="Sincronizar parcelas">
          <select v-model="config.order.syncInstallments" class="form-select">
            <option v-for="syncInstallmentsOption in syncInstallmentsOptions" :value="syncInstallmentsOption">{{$t(`${syncInstallmentsOption}.label`) }}</option>
          </select>
        </form-group>
      </div>
    </panel>

    <panel title="Serviço de entrega">
      <form-group label="Utiliza Dafiti Envios">
        <select v-model="config.order.shipmentService" class="form-select">
          <option v-for="shipmentServiceOption in shipmentServiceOptions" :value="shipmentServiceOption">{{$t(`${shipmentServiceOption}.label`) }}</option>
        </select>
      </form-group>
    </panel>


  </module-configuration>
</template>

<script>
  import api from '@/api'
  import notifier from '@/notifier'
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import ProductPriceConfiguration from '@/components/shared/ProductPriceConfiguration'
  import ExpediterConfiguration from '@/components/marketplace/shared/ExpediterConfiguration'
  import Select from '../../components/table/Select'
  import OrderRetrieveDateConfiguration from '@/components/marketplace/shared/OrderRetrieveDateConfiguration'
  import cookie from 'vue-cookie'

  export default {
    inject: ['expeditersDI', 'priceTypeDI'],
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'gfg'
      }
    },
    data: () => ({
      errors: [],
      origins: [],
      originsCountry: [],
      type: 'marketplace',
      identifier: 'gfg',
      loadingProducts: true,
      shipmentServiceOptions: [
        false,
        true
      ],
      syncInstallmentsOptions: [
        false,
        true
      ],
      resizeImageOptions: [
        false,
        true
      ],
      config: {
        auth: {
          environment: 'sandbox',
          userId: null,
          apiKey: null,
          identifier: null,
          useAPIV2: false
        },
        product: {
          price: {
            type: null,
            percent: null
          },
          stock: {
            reducer: 0
          },
          image: {
            resize: false
          },
          origin: null,
          originCountry: null
        },
        order: {
          expediter: {
            type: null,
            identifier: null
          },
          retrieveDate: null,
          shipmentService: false
        }
      }
    }),
    async mounted () {
      try {
        this.config.auth.identifier = cookie.get('merchant')
        const category = (await api.getCategories('marketplace', 'gfg'))[0]

        const attributes = await api.gfg.getAttributes(category.code)

        this.origins = attributes.find(attribute => attribute.code === 'Origin').values
        this.originsCountry = attributes.find(attribute => attribute.code === 'Origincountry').values
      } catch (e) {
        notifier.error('Impossível carregar as cores da GFG.', 'Erro')
      }

      this.loadingProducts = false
    },
    watch: {
      'config.product.stock.reducer' (value) {
        this.config.product.stock.reducer = parseInt(value)
      }
    },
    components: {
      OrderRetrieveDateConfiguration,
      Select,
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader,
      ProductPriceConfiguration,
      ExpediterConfiguration
    }
  }
</script>



// WEBPACK FOOTER //
// Gfg.vue?5d2a712e